import { useAppUser } from '@bechtel/client-common';
import { AuthPermission, AuthScope } from '@bechtel/types';
import React from 'react';

export function usePlanningPermissions() {
  const { hasPermissionScope } = useAppUser();
  const planningPermissions = React.useMemo(() => {
    const canPlanAllMilestones = hasPermissionScope({
      permission: AuthPermission.MANAGE_PLANNING,
      scope: AuthScope.ALL_WORK_PACKAGES,
    });
    const canPlanAssignedMilestones = hasPermissionScope({
      permission: AuthPermission.MANAGE_PLANNING,
      scope: AuthScope.MY_WORK_PACKAGES,
    });
    const canPlanAreaMilestones = hasPermissionScope({
      permission: AuthPermission.MANAGE_PLANNING,
      scope: AuthScope.MY_AREA,
    });
    const canViewAllCrewsProgress = hasPermissionScope({
      permission: AuthPermission.VIEW_ALL_CREWS_PROGRESS,
      scope: AuthScope.YES,
    });

    const canPlanMilestones = canPlanAssignedMilestones || canPlanAreaMilestones || canPlanAllMilestones;

    const canManageAIPlanningAll = hasPermissionScope({
      permission: AuthPermission.MANAGE_AI_PLANNING,
      scope: AuthScope.ALL_WORK_PACKAGES,
    });
    const canManageAIPlanningAssigned = hasPermissionScope({
      permission: AuthPermission.MANAGE_AI_PLANNING,
      scope: AuthScope.MY_WORK_PACKAGES,
    });
    const canManageAIPlanningArea = hasPermissionScope({
      permission: AuthPermission.MANAGE_AI_PLANNING,
      scope: AuthScope.MY_AREA,
    });
    const canManageAIPlanning = canManageAIPlanningAssigned || canManageAIPlanningArea || canManageAIPlanningAll;

    //TODO: Enable for Lead SuperIntendents
    // const canPlanAllMilestones = hasPermissionScope({
    //   permission: AuthPermission.MANAGE_PLANNING,
    //   scope: AuthScope.ALL_WORK_PACKAGES,
    // });
    const canViewPlan = hasPermissionScope({
      permission: AuthPermission.VIEW_PLANNING,
      scope: AuthScope.APPLICATION,
    });
    return {
      canPlanMilestones,
      canPlanAssignedMilestones,
      canPlanAllMilestones,
      canPlanAreaMilestones,
      canViewPlan,
      canViewAllCrewsProgress,
      canManageAIPlanning,
      canManageAIPlanningAll,
      canManageAIPlanningAssigned,
      canManageAIPlanningArea,
    };
  }, [hasPermissionScope]);
  return planningPermissions;
}
